// formatTime.js
// mm:ss elapsed-time formatter — matches room.php's timer exactly: minutes
// never roll over into an hours field (two hours reads "120:00"), only
// seconds wrap at 60. Ready for the real ticking timer added in Phase 4.
export function formatElapsedTime(totalSeconds) {
  const safeSeconds = Number.isFinite(totalSeconds) && totalSeconds > 0 ? Math.floor(totalSeconds) : 0;
  const minutes = Math.floor(safeSeconds / 60);
  const seconds = safeSeconds % 60;
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');
  return `${mm}:${ss}`;
}
